module.exports = __webpack_public_path__ + "filter.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/filter.svg?color1=%23333333&color2=
// module id = 911
// module chunks = 67